<template>
	<!-- 个人首页 -->
	<div>
		<div class="pad-1" style="padding: 0 19%;">
			<Breadcrumb style="margin-bottom: 16px;"></Breadcrumb>
			<!---->
			<!-- <router-view></router-view> -->
			<div :class="this.$route.fullPath !== '/personal/index'?'':'flex-2'">
				<navbar></navbar>
				<!-- <unlockedExperts  v-show="$route.meta.showFather"></unlockedExperts> -->
				<div v-show="$route.meta.showFather && this.$route.fullPath == '/personal/index'" class="wid-100">
					<div class="pad-2">
						<div class="box-shadow pt-1 flex-1 jus-bet mb-16 ">
							<div></div>
							<div class="logingin">
								<img :src="userInfo.avatar" class="" alt="" style="border-radius: 50%;">
								<!-- <img src="../../assets/myself/nohead.png" class="" alt=""> -->
								<p class="record-1" style="">{{userInfo.nickname}}</p>
								<!-- <p class="record-1" style="">登录/注册</p> -->
								<img src="@/assets/myself/wodevip.png" v-if="userInfo.userLevelStatus" alt=""
									@click="myVIP">
								<img src="@/assets/myself/kaitongvip.png" alt="" v-if="!userInfo.userLevelStatus"
									@click="saveVIP">
							</div>
							<div></div>

						</div>
						<div class="box-shadow " v-show="isUser">
							<div class="pad-16 mb-16">
								<div class="experts flex-1 jus-bet mb-24">
									<div class="flex-1 jus-bet">
										<div class="left-icon"></div>
										<p class="record-1">我的专家</p>
									</div>
								</div>
								<!-- 跳转专家智库 -->
								<div class="flex-1 jus-bet expert1">
									<div></div>
									<div>
										<img src="../../assets/myself/none.png" alt="">
										<p>您还没有解锁专属专家，快去专家智库中解锁并邀请专家吧!</p>
										<el-button type="primary" @click="epertList">前往:专家智库</el-button>
									</div>
									<div></div>
								</div>
							</div>
						</div>
						<collect v-show="!isUser"></collect>

					</div>


				</div>
			</div>
			<!-- <router-view></router-view> -->

		</div>
		<footers></footers>
	</div>

</template>

<script>
	import Breadcrumb from '@/views/Breadcrumb.vue';
	import navbar from '@/views/personal/navbar1.vue';
	import collect from '@/components/collect.vue';
	import footers from '@/views/footers.vue';
	import {
		getMyExpert
	} from '@/api/expert/api.js'
	export default {
		components: {
			Breadcrumb,
			footers,
			navbar,
			collect
		},
		data() {
			return {
				currentPage4: 4,
				input: '',
				value: '',
				shaiSow: false,
				isUser: false, // 登录状态
				userInfo: ''
			}
		},
		created() {
			this.userInfo = this.$store.state.activity.user;
			console.log(this.userInfo)
			console.log('this.userInfo.userLevelStatus',this.userInfo.userLevelStatus)
			// if(this.userInfo.userLevelStatus == true){

			// }
			// console.log(this.userInfo, 'this.userInfo')
		},
		mounted() {
			this.getMyExpertData();
			// console.log(this.$route.fullPath,'地址栏')
		},
		methods: {
			getMyExpertData() {
				getMyExpert().then(res => {
					if (res.code == 0) {
						let token = localStorage.getItem('keyToken');
						if (!token || !res.data.list.length) {
							this.isUser = true;
						}
					}
				})
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			hancleClick() {},
			// 专家详情
			expertDetail() {
				this.$router.push('/expert/expertDetail')
			},
			// 我的会员
			myVIP() {
				this.$router.push('/personal/member/index')
			},
			// 开通会员
			saveVIP() {
				this.$router.push('/personal/member/activateMembership')
			},
			// 前往专家智库
			epertList() {
				this.$router.push('/expert/wisdom')
			},
			clect() {
				this.shaiSow = true;
			},
			upShow() {
				this.shaiSow = false;
			}

		},

	}
</script>


<style>

</style>
<style scoped>
	.box-shadow {
		box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);

		border-radius: 8px 8px 8px 8px;
	}

	.pt-1 {
		padding: 32px 0;
		text-align: center;
	}

	.pad-1 {
		padding: 32px 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.left-icon {
		width: 6px;
		height: 20px;
		background: #3377FF;
		border-radius: 18px;
		margin-right: 10px;
	}

	.record {
		font-size: 14px;
		color: #333333;
		line-height: 21px;
		font-family: font3;
		margin-right: 8px;
	}

	.record-1 {
		font-size: 20px;
		color: #222222;
		font-family: font5;
	}

	.mb-24 {
		margin-bottom: 24px;
	}

	.mb-16 {
		margin-bottom: 16px;
	}

	.vipp div p:first-child,
	.tishi {
		font-family: font3;
		color: #666666;
		font-size: 14px;
		margin-bottom: 8px;
	}

	.vipp div p:last-child,
	.hui {
		font-family: font5;
		color: #222222;
		font-size: 16px;
	}

	.unPhoto {
		/* width: 100%;height: auto; */
	}

	.tishi {
		color: #FF4E33 !important;
	}

	.name-1 {
		font-size: 20px;
		font-family: font5;
		padding-right: 9px;
	}

	.name-2 {
		color: #999999;
		font-size: 14px;
		font-family: font3;
		white-space: nowrap;
		padding-right: 8px;
	}

	.name-3 {
		font-size: 14px;
		font-family: font3;
		font-weight: normal;
	}

	/deep/.el-pagination {
		text-align: center;
	}

	.col-22 {
		color: #222222;

	}

	.hed-img {
		width: 160px;
		height: 160px;
		padding-right: 16px;
	}

	.sex-img {
		width: 14px;
		height: 14px;
	}

	.online {
		font-size: 14px;
		color: #3377FF;
		padding: 8px 16px;
		background: #F0F5FF;
		white-space: nowrap;
		border-radius: 35px 35px 35px 35px;
	}

	.mb-8 {
		margin-bottom: 8px;
	}

	.experts p {
		font-size: 20px;
		color: #222222;
		font-family: font5;
		padding-left: 10px;
	}

	.flex-2 {
		display: flex;
		align-items: flex-start;
	}

	.check {
		/* width: 100%; */
		/* height: 352px; */
		background: #FAFAFA;
		border-radius: 4px 4px 4px 4px;
		color: #222222;
	}

	.check-1 {
		display: flex;
		/* align-items: center; */
		margin-bottom: 16px;
	}

	.check-1 p {
		padding: 4px 12px;
		font-size: 14px;
		font-family: font5;
	}

	.check-1-p {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.check-1-p p:first-child {
		color: #3377FF;
		background: #F0F5FF;
		border-radius: 8px 8px 8px 8px;
	}

	.check-p {
		margin-right: 24px;
		min-width: 74px;
	}

	.shouqi {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		cursor: pointer;
		color: #666666;
	}

	.align-1 {
		align-items: center;
	}

	.pad-16 {
		padding: 16px;
	}

	.shouqi span {
		padding-right: 8px;
	}

	.logingin img:first-child {
		width: 6.25rem;
		height: 6.25rem;
	}

	.logingin img:last-child {
		width: 7.5625rem;
		height: 2.25rem;
	}

	.logingin p {
		padding: 10px 0;
	}

	.el-button--primary {
		background-color: #3377FF;
		color: #ffffff;
		font-family: font3;
		font-size: 16px;
		/* width: 16.5%; */
	}

	.expert1 {
		text-align: center;
	}

	.expert1 p {
		color: #000000;
		font-size: 14px;
		line-height: 21px;
		font-family: font3;
		padding-bottom: 2rem;
		font-weight: normal;
	}

	.wid-100 {
		width: 100%;
	}
</style>